export function addListenersOnEctzAnchors(htmlElement) {
    const anchors = htmlElement.getElementsByClassName('ectzAnchor');
    for (let i = 0; i < anchors.length; i++) {
        const anchor = anchors[i];

        anchor.addEventListener("dragover", function (e) {
            $(this).clearQueue();
            e.preventDefault();
            if (e.target.className.indexOf('ectzAnchor') >= 0 || e.target.id.includes('dialog-move-img-') || e.target.querySelectorAll('[id^=dialog-move-img-ectz]')) {
                $(this).addClass('eazly-droppable-hover', 100);
            }
        });

        anchor.addEventListener("dragleave", function (e) {
            e.preventDefault();
            if (e.target.className.indexOf('ectzAnchor') >= 0 || e.target.id.includes('dialog-move-img-') || e.target.querySelectorAll('[id^=dialog-move-img-ectz]')) {
                $(this).removeClass('eazly-droppable-hover', 100);
            }
        });

        anchor.addEventListener("drag", function (e) {
            if (e.target.className.indexOf('ectzAnchor') >= 0 || e.target.id.includes('dialog-move-img-') || e.target.querySelectorAll('[id^=dialog-move-img-ectz]')) {
                $(this).addClass('eazly-droppable-active');
            }
        });

        anchor.addEventListener("dragend", function (e) {
            $(this).removeClass('eazly-droppable-hover');
            $(this).removeClass('eazly-droppable-active');
        });

        anchor.addEventListener("drop", function (e) {
            $(this).removeClass('eazly-droppable-hover');
            $(this).removeClass('eazly-droppable-active');
        });
    }
}

$('.row.rowDynamic').on('dragover', function () {
    return false;
});

$(".ectzAnchor").droppable({
    tolerance: "pointer"
});
